// import games from "./games.json"


import { ActivityGame, ActivityGameData, ArcademicsGame } from "modules/games/game"
import pDefer, { DeferredPromise } from "p-defer"
import { apiClient } from "infra/api-client"
import { BASE_URL } from "global"
import { MygoorooGame } from "./games-mygooroo"

function createGame(data: ActivityGameData<unknown, unknown>): ActivityGame {
  if (data.providerId === "arcademics") {
    return new ArcademicsGame(data)
  }
  else if (data.providerId === "mygooroo") {
    return new MygoorooGame(data)
  }

  throw new Error(`unknown provider ${data.providerId}`)
}


class GamesLookupService {

  private static cache_expiry = 10 * 60 * 1000;

  private defer!: DeferredPromise<ActivityGame[]>

  constructor() {
  }

  private sort(games: ActivityGame[]) {
    games.sort((g1, g2) => {
      const level1 = g1.getYearLevels(1)[0];
      const level2 = g2.getYearLevels(1)[0];
      if(level1 === level2) {
        return g1.name.localeCompare(g2.name);
      }
      return parseInt(level1) - parseInt(level2);
    })
  }

  private async fetchGames() {
    try {
      const response = await apiClient.post(BASE_URL + "games/gameList", {});
      const games = response.data.map(createGame);
      this.sort(games);
      if(this.defer) {
        this.defer.resolve(games);
      }
      setTimeout( ()=>{
        this.defer = null!;
      }, GamesLookupService.cache_expiry)
    }
    catch(error) {
      if (this.defer) {
        this.defer.reject(error);
        this.defer = null!;
      }
    }
  }

  updateGames() {
    this.defer = pDefer()
    this.fetchGames()
  }

  getGames(): Promise<ActivityGame[]> {
    if (!this.defer) {
      this.defer = pDefer()
      this.fetchGames()
    }

    return this.defer.promise
  }

  getGame(id: number): Promise<ActivityGame | null> {
    return this.getGames()
      .then(games => {
        for (const game of games) {
          if (game.id === id) {
            return game
          }
        }
        return null
      })
  }

  getProviderGame(options: {providerId: string, providerGameId: string}): Promise<ActivityGame | null> {
    return this.getGames()
      .then(games => {

        for (const game of games) {
          if (game.providerId === options.providerId
            && game.providerGameId === options.providerGameId) {
            return game
          }
        }
        return null
      })
  }


}

export const gamesLookupService = new GamesLookupService()
